var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Share / Black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share-/-Black",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 2.000000)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "share"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.25,
    cy: 9.25,
    r: 3.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 17.75,
    cy: 4,
    r: 3.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 17.75,
    cy: 16,
    r: 3.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.746,
    y1: 7.891,
    x2: 14.254,
    y2: 5.36,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.605,
    y1: 10.928,
    x2: 14.395,
    y2: 14.323,
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.db2fa2604ba0796620bdd5eced91d711.svg";
export { ForwardRef as ReactComponent };